export default [
    '$timeout',
    function ($timeout) {
        return {
            restrict: 'A',
            link(scope, element, attrs) {
                $timeout(() => element[0].focus(), 0);
            },
        };
    },
];
